import { api } from './';

interface ApiError {
  response?: {
    data: {
      status: number;
      error?: string;
      message: string;
      path?: string;
      timestamp?: string;
      details?: string[];
    };
    status: number;
    statusText: string;
  };
}

export const inserirCategoria = async (params: any) => {
  try {
    const headers = {
      'Content-Type': 'application/json',
    };

    const response = await api.post('/categoria/inserir', params, { headers });
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao comunicar com o servidor';
    throw new Error(errorMessage);
  }
};



export const editarCategoria = async (id: number, params: any) => {
  try {
    const headers = {
      'Content-Type': 'application/json',
    };
    const response = await api.put(`/categoria/editar/${id}`, params, {headers});
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao editar categoria';
    throw new Error(errorMessage);
  }
};

export const listarCategoriasAtivas = async () => {
  try {
    const response = await api.get('/categoria/ativas');
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao comunicar com o servidor';
    throw new Error(errorMessage);
  }
};

export const obterCategoria = async (id: number) => {
  try {
    const response = await api.get(`/categoria/obter/${id}`);
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao obter categoria';
    throw new Error(errorMessage);
  }
};

export const listarCategorias = async (page: number, size: number) => {
  try {
    const response = await api.get(`/categoria/listar?pagina=${page}&tamanhoPagina=${size}`);
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao listar categorias';
    throw new Error(errorMessage);
  }
};